// GENERATED by packages/contracts/scripts/generate-ts.mjs from locales/languages.json. Do not edit.
/* eslint-disable */
export const REGISTRY = {
    "languages": [
        {
            "code": "ar",
            "englishName": "Arabic",
            "nativeName": "العربية",
            "direction": "rtl",
            "status": "complete",
            "required": true,
            "fallback": [
                "en"
            ],
            "numerals": "latn"
        },
        {
            "code": "en",
            "englishName": "English",
            "nativeName": "English",
            "direction": "ltr",
            "status": "complete",
            "required": true,
            "fallback": [],
            "numerals": "latn"
        }
    ],
    "pseudo": [
        {
            "code": "en-XA",
            "base": "en",
            "direction": "ltr",
            "style": "accented"
        },
        {
            "code": "ar-XB",
            "base": "ar",
            "direction": "rtl",
            "style": "long-rtl"
        },
        {
            "code": "zh-XC",
            "base": "en",
            "direction": "ltr",
            "style": "cjk"
        },
        {
            "code": "th-XD",
            "base": "en",
            "direction": "ltr",
            "style": "tall"
        },
        {
            "code": "en-XK",
            "base": "en",
            "direction": "ltr",
            "style": "tagged"
        }
    ]
};
//# sourceMappingURL=languages.js.map